  
<nz-select (ngModelChange)="click($event)" [ngModel]="selectedValue" nzPlaceHolder="Select a operator" nzShowSearch
  [nzLoading]="isLoading">
  <nz-option *ngFor="let operator of operators" [nzValue]="operator.id" [nzLabel]="operator.name"></nz-option>
</nz-select>